import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

import Container from 'ggApp/shared/common/Container';
import { params as routerParamsSelector } from 'ggApp/modules/router/selectors';
import {
    getSubscription as getSubscriptionAction,
    setCurrentSubscriptionId as setCurrentSubscriptionIdAction,
} from 'ggApp/modules/subscription/actions';

const enhance = compose(
    connect(
        createStructuredSelector({
            params: routerParamsSelector,
        }),
        (dispatch) => ({
            getSubscription: bindActionCreators(getSubscriptionAction, dispatch),
            setCurrentSubscriptionId: bindActionCreators(setCurrentSubscriptionIdAction, dispatch),
        }),
    ),
);

class LegacyPaymentMethods extends Component {
    componentDidMount() {
        this.fetchSubscription();
    }

    fetchSubscription = () => {
        const {
            getSubscription = () => {},
            setCurrentSubscriptionId = () => {},
            params = {},
        } = this.props;

        if (params.subscriptionId) {
            getSubscription(params.subscriptionId);
            setCurrentSubscriptionId(params.subscriptionId);
        }
    };

    render() {
        return <Container />;
    }
}

export default enhance(LegacyPaymentMethods);
